import RoleRequests from '../rolerequest/RoleRequests.vue';
import NewRoleRequest from '../rolerequest/NewRoleRequest.vue';
import RejectRoleRequest from '../rolerequest/RejectRoleRequest.vue';


const routes = [{
	path: '/rolerequests',
	name: 'rolerequests',
	component: RoleRequests,
	meta: {
		authorize: [],
	},
}, {
	path: '/newrolerequest',
	name: 'newrolerequest',
	component: NewRoleRequest,
	meta: {
		authorize: [],
	},
}, {
	path: '/rejectrolerequest',
	name: 'rejectrolerequest',
	component: RejectRoleRequest,
	meta: {
		authorize: [],
	},
}];

export default routes;
